import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { NavLink as Link } from 'react-router-dom';

import { getSearchUrl as _ } from '../../utils/urls';
import {SALE, APARTMENTS, LANDS, COMMERCIALS, GARAGES, RENTDAILY, ADFOX} from '../../consts';
import {
  RESIDENTIAL_COMPLEX, COTTAGE_VILLAGE,
  SALE_APARTMENTS_1_ROOM, SALE_APARTMENTS_2_ROOM, SALE_APARTMENTS_3_ROOM, SALE_APARTMENTS_ROOMS,
  RENT_APARTMENTS_1_ROOM, RENT_APARTMENTS_2_ROOM, RENT_APARTMENTS_3_ROOM, RENT_APARTMENTS_ROOMS,
  RENT_APARTMENTS_HOUSE,
  SALE_LAND_HOUSE, SALE_LAND_DACHA, SALE_LAND_COTTAGE, SALE_LAND_TOWNHOUSE, SALE_LAND_LANDS,
  GARAGES_CAPITAL, GARAGES_CONCRETE, GARAGES_METAL, GARAGES_PLACE, GARAGES_TODAY, GARAGES_WEEK,
  SALE_COMMERCIALS_OFFICE, SALE_COMMERCIALS_SHELF_SPACE, SALE_COMMERCIALS_WAREHOUSE, SALE_COMMERCIALS_CATERING,
  SALE_COMMERCIALS_SERVICE_STATION, SALE_COMMERCIALS_BUSINESS, SALE_COMMERCIALS_FREE, SALE_COMMERCIALS_OWNER,
  RENT_COMMERCIALS_OFFICE, RENT_COMMERCIALS_SHELF_SPACE, RENT_COMMERCIALS_WAREHOUSE, RENT_COMMERCIALS_CATERING,
  RENT_COMMERCIALS_SERVICE_STATION, RENT_COMMERCIALS_BUSINESS, RENT_COMMERCIALS_FREE, RENT_COMMERCIALS_OWNER
} from '../../utils/aliases';
import {AdFoxSplitter} from '../Widgets';

const banners = {
  [APARTMENTS]: true
};

const aliases = {
  [LANDS]: [
    {
      items: [
        {href: SALE_LAND_HOUSE, label: 'Дома'},
        {href: SALE_LAND_COTTAGE, label: 'Коттеджи'}
      ]
    }, {
      items: [
        {href: SALE_LAND_TOWNHOUSE, label: 'Таунхаусы'},
        {href: SALE_LAND_DACHA, label: 'Дачи'}
      ]
    }, {
      items: [
        {href: SALE_LAND_LANDS, label: 'Земельные участки'},
        {href: COTTAGE_VILLAGE, label: 'Коттеджные поселки'}
      ]
    }
  ],
  [GARAGES]: [
    {
      items: [
        {href: GARAGES_CAPITAL, label: 'Капитальный гараж'},
        {href: GARAGES_CONCRETE, label: 'Железобетонный гараж'}
      ]
    }, {
      items: [
        {href: GARAGES_METAL, label: 'Металлический гараж'},
        {href: GARAGES_PLACE, label: 'Машиноместо'}
      ]
    }, {
      items: [
        {href: GARAGES_TODAY, label: 'За сегодня'},
        {href: GARAGES_WEEK, label: 'За неделю'}
      ]
    }
  ],
  [APARTMENTS]: [
    {
      title: 'Купить квартиру',
      items: [
        {href: SALE_APARTMENTS_1_ROOM, label: '1-комнатные квартиры'},
        {href: SALE_APARTMENTS_2_ROOM, label: '2-комнатные квартиры'},
        {href: SALE_APARTMENTS_3_ROOM, label: '3-комнатные квартиры'},
        {href: SALE_APARTMENTS_ROOMS, label: 'Комнаты'},
        {href: RESIDENTIAL_COMPLEX, label: 'Жилые комплексы'}
      ]
    }, {
      title: 'Купить дом, участок',
      items: [
        {href: SALE_LAND_HOUSE, label: 'Дома'},
        {href: SALE_LAND_COTTAGE, label: 'Коттеджи'},
        {href: SALE_LAND_DACHA, label: 'Дачи'},
        {href: SALE_LAND_LANDS, label: 'Земельные участки'},
        {href: COTTAGE_VILLAGE, label: 'Коттеджные поселки'}
      ]
    }, {
      title: 'Снять квартиру',
      items: [
        {href: RENT_APARTMENTS_1_ROOM, label: '1-комнатные квартиры'},
        {href: RENT_APARTMENTS_2_ROOM, label: '2-комнатные квартиры'},
        {href: RENT_APARTMENTS_3_ROOM, label: '3-комнатные квартиры'},
        {href: RENT_APARTMENTS_ROOMS, label: 'Комнаты'},
        {href: RENT_APARTMENTS_HOUSE, label: 'Дома'},
        {href: _(RENTDAILY, APARTMENTS), label: 'Посуточно'}
      ]
    }
  ],
  [COMMERCIALS]: [
    {
      title: 'Продажа',
      items: [
        {href: SALE_COMMERCIALS_OFFICE, label: 'Офисные помещения'},
        {href: SALE_COMMERCIALS_SHELF_SPACE, label: 'Торговые площади/Магазины'},
        {href: SALE_COMMERCIALS_WAREHOUSE, label: 'Склады/Производство'},
        {href: SALE_COMMERCIALS_CATERING, label: 'Общепит/Досуг'}
      ]
    },
    {
      title: '\u00A0',
      items: [
        {href: SALE_COMMERCIALS_SERVICE_STATION, label: 'СТО'},
        {href: SALE_COMMERCIALS_BUSINESS, label: 'Готовый бизнес'},
        {href: SALE_COMMERCIALS_FREE, label: 'Площади свободного назначения'},
        {href: SALE_COMMERCIALS_OWNER, label: 'Частные объявления'}
      ]
    }, {
      title: 'Аренда',
      items: [
        {href: RENT_COMMERCIALS_OFFICE, label: 'Офисные помещения'},
        {href: RENT_COMMERCIALS_SHELF_SPACE, label: 'Торговые площади/Магазины'},
        {href: RENT_COMMERCIALS_WAREHOUSE, label: 'Склады/Производство'},
        {href: RENT_COMMERCIALS_CATERING, label: 'Общепит/Досуг'}
      ]
    }, {
      title: '\u00A0',
      items: [
        {href: RENT_COMMERCIALS_SERVICE_STATION, label: 'СТО'},
        {href: RENT_COMMERCIALS_BUSINESS, label: 'Готовый бизнес'},
        {href: RENT_COMMERCIALS_FREE, label: 'Площади свободного назначения'},
        {href: RENT_COMMERCIALS_OWNER, label: 'Частные объявления'}
      ]
    }
  ]
};

class AliasMenu extends Component {
  renderOffer (key) {
    if (!banners[key]) {
      return null;
    }

    const { dealType, realtyType, regionName } = this.props;

    return (
      <AdFoxSplitter
        regionName={regionName}
        position={ADFOX.homeAliasMenu}
        dealType={dealType}
        realtyType={realtyType} />
    );
  }

  renderAliases (key) {
    return (
      <div className='alias-section-content'>
        {
          aliases[key].map((col, cIndex) => {
            return (
              <div key={cIndex} className='alias-block' >
                {col.title && <h3 className='alias-title'>{col.title}</h3>}

                <ul className='alias-list list-inline' >
                  {
                    col.items.map((item, iIndex) => {
                      return (
                        <li key={iIndex}>
                          {
                            item.link
                              ? <Link className='btn btn-underline' to={item.link}>{item.label}</Link>
                              : <a className='btn btn-underline' href={item.href}>{item.label}</a>
                          }
                        </li>
                      );
                    })
                  }
                </ul>
              </div>
            );
          })
        }

        { this.renderOffer(key) }
      </div>
    );
  }

  render () {
    const { dealType, realtyType } = this.props;
    return (
      <div className='alias-section'>
        { dealType === SALE && realtyType === APARTMENTS && this.renderAliases(APARTMENTS) }
        { dealType === SALE && realtyType === LANDS && this.renderAliases(LANDS) }
        { dealType === SALE && realtyType === COMMERCIALS && this.renderAliases(COMMERCIALS) }
        { dealType === SALE && realtyType === GARAGES && this.renderAliases(GARAGES) }
      </div>
    );
  }
}

AliasMenu.propTypes = {
  regionName: PropTypes.string.isRequired,
  dealType: PropTypes.string.isRequired,
  realtyType: PropTypes.string.isRequired
};
AliasMenu.defaultProps = {};

export default AliasMenu;



// WEBPACK FOOTER //
// ./src/ui/Menu/AliasMenu.jsx